// extracted by mini-css-extract-plugin
export default {"root":"Card_root__ix+A3","header":"Card_header__FCL3B","title":"Card_title__URhiP","subtitle":"Card_subtitle__Qfa6x","exit":"Card_exit__rugpl"};